const sizes = [
    {
        value: 16,
        low: 2000,
        max: 10000,
    },
    {
        value: 12.8,
        low: 0,
        max: 2000,
    },
];

const getSize = (width) => {
    for (const size of sizes) {
        if (width >= size.low && width < size.max) {
            return size.value;
        }
    }
};

const useResolutionChange = () => {
    const size = getSize(window.innerWidth);
    document.documentElement.style.setProperty('--main-font', `${size}px`);
};

export default useResolutionChange;
